import React from 'react';
import AddressLabel from './AddressLabel';

class AddressCard extends React.Component {
  render() {
    const {
      item: address,
      index,
      editAddress = () => {},
      deleteAddress = () => {},
      markDefaultAddress = () => {},
      totalCards,
      canEdit = false
    } = this.props;
    return (
      <div className="infinity-card">
        <div className="address-card">
          <AddressLabel address={address} />
          <div className="address-card__ctas">
            {canEdit && (
              <div
                className="a--blue address-card__cta"
                onClick={() => editAddress(index)}
              >
                Edit
              </div>
            )}
            {!address.default && (
              <div
                className="a--blue address-card__cta"
                onClick={() => markDefaultAddress(index)}
              >
                Make Default
              </div>
            )}
            {totalCards > 1 && (
              <div
                className="a--red address-card__cta"
                onClick={() => deleteAddress(index)}
              >
                Delete
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default AddressCard;



// WEBPACK FOOTER //
// ./src/components/shared/AddressCard.js